import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService} from "../services";
import {Subject} from "rxjs";
import {FormBuilder, FormGroup} from "@angular/forms";
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {locale as polish} from "./i18n/pl";
import {locale as english} from "./i18n/en";
import {first} from "rxjs/operators";

import {MatDialog} from "@angular/material/dialog";
import {Page} from "../models/page";
import {NoteService} from "./service/note.service";
import {Notes} from "./model/notes";
import {NoteConfirmDialogComponent} from "./dialog/noteConfirmDialog.component";
import {Note} from "./model/note";
import {NoteDeleteDialogComponent} from "./dialog/noteDeleteDialog.component";
import {ResponseDialogComponent} from "./dialog/responseDialog.component";


@Component({
    templateUrl: './note.component.html',
    styleUrls: ['./note.component.scss',]
})


export class NoteComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    deleteDialogRef: any;
    confirmDialogRef: any;
    responseDialogRef: any;

    page = new Page();
    @ViewChild(DatatableComponent) table: DatatableComponent;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private noteService: NoteService,
        private alertService: AlertService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private formBuilder: FormBuilder,
        public _matDialog: MatDialog,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;
        this.page.pageNumber = 0;
        this.page.size = 100;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Notes');
    }

    ngOnInit() {
        this.setPage({offset: 0});
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    setPage(pageInfo) {
        this.loadingIndicator = true;
        this.rows = [];
        this.page.totalElements = 0;
        this.page.pageNumber = pageInfo.offset;

        if (typeof pageInfo.limit === "undefined") {
            pageInfo.limit = this.page.size;
        }


        this.noteService.getAll(pageInfo.offset * pageInfo.limit, pageInfo.limit, null, null).pipe(first())
            .subscribe((res: Notes) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.total;
                    // this.page = pagedData.page;
                },
                error => {
                    this.alertService.error(error);
                })
    }

    confirmNote(note: Note): void {
        this.confirmDialogRef = this._matDialog.open(NoteConfirmDialogComponent, {
            panelClass: 'note-confirm-dialog',
            data      : {
                action : 'confirm-note',
                note: note,
            },
            width: '550px',
        });

        this.confirmDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.noteService.confirm(note.id, {}).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.confirmDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    responseNote(note: Note): void {
        this.confirmDialogRef = this._matDialog.open(ResponseDialogComponent, {
            panelClass: 'response-dialog',
            data      : {
                action : 'response-note',
                note: note,
            },
            width: '550px',
        });

        this.confirmDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.noteService.response(response.getRawValue()).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.confirmDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    deleteNote(note: Note): void {
        this.confirmDialogRef = this._matDialog.open(NoteDeleteDialogComponent, {
            panelClass: 'note-delete-dialog',
            data      : {
                action : 'delete-note',
                note: note,
            },
            width: '550px',
        });

        this.confirmDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.noteService.delete(note.id).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.confirmDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

}
